/* eslint-disable import/no-named-as-default, import/no-named-as-default-member */
import $ from 'jquery';
import LazyLoad from 'vanilla-lazyload';
import cookiePopup from '../blocks/cookie-popup';
import bodyBackgroundImage from '../components/c-background-image';
import cAppeared from '../components/c-appeared';
import cOutline from '../components/c-outline';
import bookingWidget from '../components/modules/booking/widget';
import crisisMessage from '../blocks/crisis-message';
import initializeLinkPopups from '../components/modules/popupLink';
// eslint-disable-next-line import/no-extraneous-dependencies, import/extensions
import videojs from 'video.js/dist/alt/video.novtt.js';

window.videojs = videojs;

cookiePopup();
bodyBackgroundImage();
cAppeared();
crisisMessage();
initializeLinkPopups();

if (document.querySelector('.booking-widget')) {
  cOutline();
  // eslint-disable-next-line no-undef
  bookingWidget(jQuery);
}
/**
 * Common JS functions
 */

// eslint-disable-next-line func-names
const isElementExists = function isElementExists(element) {
  return typeof (document.querySelector(element)) != 'undefined' && document.querySelector(element) != null;
};

// eslint-disable-next-line func-names
const elemColorByWindowScroll = function elemColorByWindowScroll(element, pull) {
  $(element).each((i, letter) => {
    const l = $(letter).offset().top - $(window).scrollTop();

    $(letter).addClass('brand');

    // eslint-disable-next-line consistent-return
    pull.forEach((section) => {
      if (!isElementExists(section)) {
        return false;
      }

      $(section).each(function () {
        const l2 = $(this).offset().top - $(window).scrollTop();
        // 70 is hand-picked number to make the transition consistent with the sticku menu
        const l3 = $(this).offset().top - $(window).scrollTop() + $(this).height() - 70;

        if (l > l2 && l < l3) {
          $(letter).removeClass('brand');
        }
      });
    });
  });
};

global.isElementExists = isElementExists;
global.elemColorByWindowScroll = elemColorByWindowScroll;

// eslint-disable-next-line no-shadow
(function ($) {
  global.breakpoints = {
    mobile: 576,
    tablet: 768,
    desktop: 992,
  };

  // eslint-disable-next-line consistent-return,no-param-reassign
  $.fn.overflowing = function (options, callback) {
    const self = this;
    const overflowed = [];
    const hasCallback = !!(callback && typeof callback === 'function');
    let status = false;
    this.options = options || window;
    // eslint-disable-next-line consistent-return
    this.each(function () {
      if ($.isWindow(this)) {
        return false;
      }
      const $this = $(this);
      const elPosition = $this.position();
      const elWidth = $this.width();
      const elHeight = $this.height();
      const parents = $this.parentsUntil(self.options);
      const $parentsTo = $(self.options);
      parents.push($parentsTo);
      for (let i = 0; i < parents.length; i++) {
        const $parent = $(parents[i]);
        if ($.isWindow($parent[0])) {
          break;
        }
        // eslint-disable-next-line no-bitwise
        const absPosition = !!~['absolute', 'fixed'].indexOf($parent.css('position'));
        const parentPosition = $parent.position();
        const parentWidth = $parent.width();
        const parentHeight = $parent.height();
        const parentToBottom = absPosition ? parentHeight : (parentHeight + parentPosition.top);
        const parentToRight = absPosition ? parentWidth : (parentWidth + parentPosition.left);
        if (elPosition.top < 0
          || elPosition.left < 0
          || elPosition.top > parentToBottom
          || elPosition.left > parentToRight
          || (elPosition.top + elHeight) > parentToBottom
          || (elPosition.left + elWidth) > parentToRight) {
          status = true;
          $(parents[i]).addClass('overflowed');
          overflowed.push(parents[i]);
          if (hasCallback) {
            callback(parents[i]);
          }
        }
      }
      if ($this.parents(self.options).hasClass('overflowed')) {
        $this.addClass('overflowing');
      }
    });

    if (!hasCallback) {
      return overflowed.length > 1 ? overflowed : status;
    }
  };

  const brandColor = getComputedStyle(document.documentElement);
  const brandColorValue = brandColor.getPropertyValue('--color-brand').trim();

  if (brandColorValue === '#05274d' || brandColorValue === '#002045') {
    $('.footer-top__container').addClass('changed-form-color-initial');
  } else {
    $('.footer-top__container').addClass('changed-form-color');
  }
// eslint-disable-next-line no-undef
}(jQuery));

document.addEventListener('DOMContentLoaded', () => {
  const video = document.querySelector('#heroVideo');

  if (video) {
    video.play();
  }

  // eslint-disable-next-line no-unused-vars
  const lazy = new LazyLoad({
    elements_selector: '.lazy',
  });
});

// Using wpcf7submit instead of wpcf7mailsent to catch custom status
document.addEventListener('wpcf7submit', (event) => {
  const formWrapper = event.target;
  const { apiResponse } = event.detail;

  // support for redirect_link in form response
  if ('redirect_link' in apiResponse) {
    $('.wpcf7-response-output', $(event.target)).attr('hidden', true);
    window.location.href = apiResponse.redirect_link;
  }

  // relay the email to another page if there is 'reSubmit' in form response
  // this useful for signup flow where the sign-up page prefills its own form
  // from POST. We post a bare email field instead of re-submitting the CF7 form:
  // without `_wpcf7` in the payload CF7 ignores the request, so the already
  // spent Turnstile token is never sent for verification a second time.
  if ('reSubmit' in apiResponse) {
    const form = formWrapper.closest('form') || formWrapper.querySelector('form');
    const email = form && form.querySelector('input[name="email"]');

    if (email) {
      const relay = document.createElement('form');
      relay.method = 'post';
      relay.action = form.action;

      const field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'email';
      field.value = email.value;

      relay.appendChild(field);
      document.body.appendChild(relay);
      relay.submit();
    }
  }
});

document.addEventListener('wpcf7mailsent', (event) => {
  const formWrapper = event.target;

  // clear email field with default:post value on signup flow
  if (formWrapper.classList.contains('js-wpcf7-form-signup-flow')) {
    const email = formWrapper.querySelector('input[type="email"]');

    if (email) {
      setTimeout(() => {
        email.value = '';
      }, 500);
    }
  }
});

// CLS decrease
document.fonts.ready.then(() => {
  const triggerClass = 'cls--hidden';
  const blocks = document.querySelectorAll(`.${triggerClass}`);

  if (blocks.length) {
    blocks.forEach((el) => {
      el.classList.remove(triggerClass);
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const initVideoJsPlayer = (video) => {
    if (video.dataset.vjsInitialized) return;
    // eslint-disable-next-line no-param-reassign
    video.dataset.vjsInitialized = 'true';

    const videoJsPlayer = videojs(video, {
      // allow autoplay when muted
      autoplay: true,
      muted: true,
      loop: true,
      html5: {
        vhs: {
          overrideNative: true,
          limitRenditionByPlayerDimensions: true,
          useDevicePixelRatio: true,
          bandwidth: 5000000,
        },
      },
    });
    videoJsPlayer.ready(() => {
      // ensure playback starts (some browsers still require play call)
      try {
        videoJsPlayer.play();
      } catch (e) {
        // ignore play() rejection — autoplay may be blocked
      }

      if (video.classList.contains('hasPlayPause') && video.tagName === 'VIDEO-JS') {
        const videoElem = videoJsPlayer.el().querySelector('video');

        if (videoElem) {
          initVideoControls([videoElem], 100 + Math.floor(Math.random() * 200));
        }
      }
    });
  };

  const lazyLoadVideoJs = (video) => {
    let timeoutId;
    const initOnInteraction = () => {
      clearTimeout(timeoutId);
      initVideoJsPlayer(video);
      window.removeEventListener('scroll', initOnInteraction);
      window.removeEventListener('touchstart', initOnInteraction);
      window.removeEventListener('mousemove', initOnInteraction);
    };

    const scheduleTimeout = () => {
      timeoutId = setTimeout(initOnInteraction, 2000);
    };

    if (document.readyState === 'complete') {
      scheduleTimeout();
    } else {
      window.addEventListener('load', scheduleTimeout, { once: true });
    }

    window.addEventListener('scroll', initOnInteraction, { once: true, passive: true });
    window.addEventListener('touchstart', initOnInteraction, { once: true, passive: true });
    window.addEventListener('mousemove', initOnInteraction, { once: true, passive: true });
  };

  document.querySelectorAll('video-js.autoDetect').forEach((video) => {
    lazyLoadVideoJs(video);
  });

  document.querySelectorAll('video-js.enabledPoster').forEach((video) => {
    const initPosterVideo = () => {
      if (!video.dataset.vjsInitializedPoster) {
        // eslint-disable-next-line no-param-reassign
        video.dataset.vjsInitializedPoster = 'true';
        // Preload poster image to speed up display
        try {
          const posterUrl = video.getAttribute('poster');
          if (posterUrl) {
            const img = new Image();
            img.src = posterUrl;
          }
        } catch (e) {
          // noop
        }

        videojs(video);
      }
    };

    let timeoutId;
    const initOnInteraction = () => {
      clearTimeout(timeoutId);
      initPosterVideo();
      window.removeEventListener('scroll', initOnInteraction);
      window.removeEventListener('touchstart', initOnInteraction);
    };

    const scheduleTimeout = () => {
      timeoutId = setTimeout(initOnInteraction, 2000);
    };

    if (document.readyState === 'complete') {
      scheduleTimeout();
    } else {
      window.addEventListener('load', scheduleTimeout, { once: true });
    }

    window.addEventListener('scroll', initOnInteraction, { once: true, passive: true });
    window.addEventListener('touchstart', initOnInteraction, { once: true, passive: true });
  });
});